import { render, staticRenderFns } from "./AddRegister.vue?vue&type=template&id=64b26a60&scoped=true&"
import script from "./AddRegister.vue?vue&type=script&lang=js&"
export * from "./AddRegister.vue?vue&type=script&lang=js&"
import style0 from "./AddRegister.vue?vue&type=style&index=0&id=64b26a60&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b26a60",
  null
  
)

export default component.exports